var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingIconYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E5C247;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M458.4,380.7c-8.9-6.6-21.4-4.8-28,4.1c-3.6,4.9-7.5,9.7-11.5,14.2c-7.3,8.3-6.5,20.9,1.7,28.2 c3.8,3.4,8.5,5,13.2,5c5.5,0,11-2.3,15-6.8c4.8-5.4,9.4-11.1,13.7-16.8C469.1,399.8,467.3,387.3,458.4,380.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M491.9,286.9c-10.8-2.3-21.4,4.5-23.8,15.3c-1.3,5.9-2.9,11.9-4.6,17.7c-3.3,10.6,2.7,21.8,13.2,25 c2,0.6,4,0.9,5.9,0.9c8.5,0,16.4-5.5,19.1-14.1c2.1-6.9,4-13.9,5.5-21C509.5,299.9,502.6,289.2,491.9,286.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M362.1,444.7c-5.3,3-10.8,5.7-16.3,8.2c-10.1,4.5-14.5,16.4-10,26.5c3.3,7.4,10.6,11.8,18.2,11.8 c2.8,0,5.5-0.6,8.2-1.8c6.6-3,13.1-6.2,19.4-9.8c9.6-5.4,13.1-17.6,7.7-27.2C384,442.8,371.8,439.4,362.1,444.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236,96v151.7l-73.3,73.3c-7.8,7.8-7.8,20.5,0,28.3c3.9,3.9,9,5.9,14.1,5.9c5.1,0,10.2-2,14.1-5.9l79.2-79.2 c3.8-3.8,5.9-8.8,5.9-14.1V96c0-11-9-20-20-20C245,76,236,85,236,96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M492,43c-11,0-20,9-20,20v55.5C425.4,45.5,344.2,0,256,0C187.6,0,123.3,26.6,75,75C26.6,123.3,0,187.6,0,256 s26.6,132.7,75,181c48.4,48.4,112.6,75,181,75c0.2,0,0.3,0,0.5,0c0.2,0,0.3,0,0.5,0c7.2,0,14.5-0.3,21.6-0.9 c11-0.9,19.2-10.6,18.3-21.6c-0.9-11-10.6-19.2-21.6-18.3c-6,0.5-12.2,0.8-18.3,0.8c-0.2,0-0.3,0-0.5,0c-0.2,0-0.3,0-0.5,0 c-119.1,0-216-96.9-216-216S136.9,40,256,40c76.8,0,147.4,40.9,185.9,106h-55c-11,0-20,9-20,20s9,20,20,20H448 c12.2,0,23.6-3.4,33.3-9.4c0.6-0.4,1.2-0.7,1.8-1.2C500.5,164,512,144.3,512,122V63C512,52,503,43,492,43z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIconYellow);
export default __webpack_public_path__ + "static/media/pending_icon-yellow.86f710ed33987e78a348bcb95a4094ed.svg";
export { ForwardRef as ReactComponent };